export const SUP_EQUIPMENT_REPAIRS_LOADER = {
  desktop: `
<div class="cui">
  <div class="cui-grid">
    <div class="cui-container">
      <div class="cui-row">
        <div class="cui-col-lg-4 cui-col-md-3 cui-col-sm-4" style="padding-bottom: 40px; padding-top: 120px;">
          <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description" style="height: 18px; width: 100%;"></div>
          </div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-bottom-80">
        <div class="cui-col-lg-7 cui-col-md-8 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
            <div class="cui-skeleton__item" style="width: 100%; height: 52px;"></div>
          </div>
          <div class="cui-skeleton-paragraph -size--small -resolution--desktop">
            <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-bottom-80 -spacing--padding-top-80" style="align-items: flex-start;">
        <div class="cui-col-lg-6 cui-col-md-8 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 800px;"></div>
          </div>
        </div>
        <div class="cui-col-lg-6 cui-col-md-8 cui-col-sm-4">
          <div style="padding-left: 77px; display: flex; flex-direction: column; gap: 24px;">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 324px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 232px;"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-top-80 -spacing--padding-bottom-40">
        <div class="cui-col-lg-12 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="cui-row -spacing--padding-bottom-80">
        <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 296px;"></div></div>
        </div>
        <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 296px;"></div></div>
        </div>
        <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 296px;"></div></div>
        </div>
        <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 296px;"></div></div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-top-80 -spacing--padding-bottom-40">
        <div class="cui-col-lg-12 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="cui-row -spacing--padding-bottom-80">
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div></div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-top-80 -spacing--padding-bottom-40">
        <div class="cui-col-lg-12 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="cui-row -spacing--padding-bottom-80">
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-top-80 -spacing--padding-bottom-40">
        <div class="cui-col-lg-12 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="cui-row -spacing--padding-bottom-80">
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-top-80 -spacing--padding-bottom-80">
        <div class="cui-col-lg-4 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
        <div class="cui-col-lg-8 cui-col-md-8 cui-col-sm-4">
          <div style="display: flex; flex-direction: column; gap: 4px;">
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`,
  mobile: `
<div class="cui">
  <div class="cui-grid">
    <div class="cui-container">
      <div class="cui-row">
        <div class="cui-col-lg-4 cui-col-md-3 cui-col-sm-4 -spacing--padding-bottom-40" style="padding-top: 60px;">
            <div class="cui-skeleton-paragraph -size--small -resolution--desktop">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                    <div class="cui-skeleton__item cui-skeleton__description">

                    </div>
                </div>
            </div>
        </div>
      </div>

      <div class="cui-row">
        <div class="cui-col-lg-7 cui-col-md-8 cui-col-sm-4" style="padding-bottom: 20px;">
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
            <div class="cui-skeleton__item" style="width: 100%; height: 52px;"></div>
          </div>
          <div class="cui-skeleton-paragraph -size--small -resolution--desktop">
            <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
                <div class="cui-skeleton__item cui-skeleton__description"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="cui-row" style="align-items: flex-start; flex-direction: column; row-gap: 24px; padding-bottom: 20px; padding-top: 20px;">
        <div class="cui-col-lg-6 cui-col-md-8 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 1994px;"></div>
          </div>
        </div>
        <div class="cui-col-lg-6 cui-col-md-8 cui-col-sm-4">
          <div style="padding-left: 0; display: flex; flex-direction: column; gap: 24px;">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 324px;"></div>
            </div>
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 232px;"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-bottom-24" style="padding-top: 20px;">
        <div class="cui-col-lg-12 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="cui-row" style="row-gap: 24px; padding-bottom: 20px;">
        <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 296px;"></div></div>
        </div>
        <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 296px;"></div></div>
        </div>
        <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 296px;"></div></div>
        </div>
        <div class="cui-col-lg-3 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 296px;"></div></div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-bottom-24" style="padding-top: 20px;">
        <div class="cui-col-lg-12 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="cui-row" style="row-gap: 24px; padding-bottom: 20px;">
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 184px;"></div></div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-bottom-24" style="padding-top: 20px;">
        <div class="cui-col-lg-12 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="cui-row" style="row-gap: 24px; padding-bottom: 20px;">
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
      </div>

      <div class="cui-row -spacing--padding-bottom-24" style="padding-top: 20px;">
        <div class="cui-col-lg-12 cui-col-md-8 cui-col-sm-4">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="cui-row" style="row-gap: 24px; padding-bottom: 20px;">
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
        <div class="cui-col-lg-4 cui-col-md-4 cui-col-sm-4">
          <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 512px;"></div></div>
        </div>
      </div>

      <div class="cui-row" style="padding-top: 20px; padding-bottom: 20px;">
        <div class="cui-col-lg-4 cui-col-md-8 cui-col-sm-4 -spacing--padding-bottom-24">
            <div class="cui-skeleton-heading -size--extra-large -resolution--desktop">
                <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
                    <div class="cui-skeleton__item cui-skeleton-heading__title">
                    </div>
                </div>
            </div>
        </div>
        <div class="cui-col-lg-8 cui-col-md-8 cui-col-sm-4">
          <div style="display: flex; flex-direction: column; gap: 4px;">
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
            <div class="cui-skeleton-rectangle -is--block"><div class="cui-skeleton__item" style="width: 100%; height: 72px;"></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
};
